<span class="icon"
      *ngIf="!isLoading"
      (click)="showOptions = true">
  <app-download-tooltip-icon
      [text]="tooltipText">
  </app-download-tooltip-icon>
</span>

<app-spinner-icon *ngIf="isLoading"></app-spinner-icon>

<div class="dropdown" [class.show]="showOptions">
  <div *ngFor="let option of options" (click)="handleClick(option)">
    {{ option }}
  </div>
</div>